import { SplittingConfig } from './types';

/**
 * テキスト分割ユーティリティクラス
 */
export class TextSplitter {
  private config: SplittingConfig;

  constructor(config: SplittingConfig) {
    this.config = config;
  }

  /**
   * テキストを分割すべきかどうかを判定
   */
  shouldSplit(text: string): boolean {
    if (!this.config.enabled) {
      return false;
    }

    const hasDelimiters = this.config.delimiters.test(text);
    const isLongText = text.length > this.config.minLength;

    return isLongText && hasDelimiters;
  }

  /**
   * テキストを句読点で分割
   */
  split(text: string): string[] {
    if (!this.shouldSplit(text)) {
      return [text];
    }

    // 句読点で分割
    const segments = text.split(/([。！？])/).filter((segment) => segment.trim().length > 0);

    // 句読点を前の文に結合
    const result: string[] = [];
    for (let i = 0; i < segments.length; i += 2) {
      const content = segments[i];
      const delimiter = segments[i + 1] || '';
      const combined = (content + delimiter).trim();

      if (combined.length > 0) {
        result.push(combined);
      }
    }

    // 短すぎるセグメントを前のセグメントと結合
    return this.mergeShortSegments(result);
  }

  /**
   * 短いセグメントを結合
   */
  private mergeShortSegments(segments: string[]): string[] {
    const result: string[] = [];

    for (const segment of segments) {
      if (segment.length < this.config.segmentMinLength && result.length > 0) {
        // 前のセグメントと結合
        result[result.length - 1] += segment;
      } else {
        result.push(segment);
      }
    }

    return result;
  }

  /**
   * 設定を更新
   */
  updateConfig(config: Partial<SplittingConfig>): void {
    this.config = { ...this.config, ...config };
  }
}
